module.exports = __webpack_public_path__ + "img/no-contract.36704fef.png";